// ============================================================================
// Placeholder Image
// ============================================================================

const placeholderSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
  <rect width="200" height="200" fill="#e9ecef"/>
  <g transform="translate(100,85)" text-anchor="middle">
    <svg x="-20" y="-28" width="40" height="40" viewBox="0 0 16 16" fill="#adb5bd">
      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
    </svg>
    <text font-family="system-ui,sans-serif" font-size="13" fill="#adb5bd" dy="30" font-weight="500">No Image</text>
  </g>
</svg>`

export const PLACEHOLDER_IMAGE = `data:image/svg+xml,${encodeURIComponent(placeholderSvg)}`

/**
 * Returns the image src with fallback chain:
 * 1. Product's own image_url
 * 2. Category fallback image (from categoryImageMap)
 * 3. Generic placeholder SVG
 *
 * Backwards compatible — category and categoryImageMap are optional.
 */
export const getProductImage = (
  url: string | null | undefined,
  category?: string | null,
  categoryImageMap?: Record<string, string>,
): string => {
  if (url?.trim()) return url
  if (category && categoryImageMap?.[category]) return categoryImageMap[category]
  return PLACEHOLDER_IMAGE
}

/**
 * onError handler — swaps a broken image for the category fallback or placeholder.
 * Pass category + map for category-level fallback, or omit for direct placeholder.
 */
export const handleImageError = (
  e: React.SyntheticEvent<HTMLImageElement>,
  category?: string | null,
  categoryImageMap?: Record<string, string>,
) => {
  const img = e.currentTarget
  // Try category fallback first
  if (category && categoryImageMap?.[category] && img.src !== categoryImageMap[category]) {
    img.src = categoryImageMap[category]
    return
  }
  // Final fallback to placeholder
  if (img.src !== PLACEHOLDER_IMAGE) {
    img.src = PLACEHOLDER_IMAGE
  }
}
